// Текст заметки по компании. Заметка, в которой ничего нет (или одни пробелы и переносы строк), не
// заметка. Те же правила проверяет сервер (services/main, helpers/memoText.js).
export const MEMO_MAX = 5000;

// Что сказать человеку про заметку (пустая строка, если всё в порядке).
export const memoError = (value) => {
  if (typeof value !== "string" || !value.trim()) return "Введите текст заметки";
  if (value.trim().length > MEMO_MAX) return `Заметка: не длиннее ${MEMO_MAX} знаков`;
  return "";
};
